module.exports = __webpack_public_path__ + "static/media/rentRates-1bedroom-alldwelling-02.0d5cbd8d.png";